
//import { useNavigate } from "react-router-dom";

import { AppFooter } from "../../components/footer/footer";
import { AppHeader } from "../../components/header/header";

import "../../styles/home.css";
import "../..//styles/about.css";

export const AboutUs = () => {
     
    //const navigateTo = useNavigate();

    return (
        <div className="min-v">
            <AppHeader />
            <div className="page-cap">About Pathfinders STEM Hub</div>
            <div className="about-text">
                <p>
                    Pathfinders eSTEM Hub is an interactive online learning platform designed to make STEM (Science, Technology, Engineering, and Mathematics) education fun, accessible, and practical for children and youth aged 10-24 years especially those from under-resourced and crisis-affected communities.

                </p>
                <p>
                   Through hands-on lessons, creative digital tools, and real-world problem-solving projects, we empower the next generation of thinkers, builders, and changemakers. Whether you're exploring coding, robotics, renewable energy, or science experiments, the eSTEM Hub is your gateway to a brighter, smarter future. 
                </p>
                <p>
                    With built-in AI support, learners can initiate prompts, ask questions, and receive real-time guidance as they explore and create while making learning more personalized and engaging than ever before.

                </p>
            </div>
            <AppFooter />
        </div>
    )
}